import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CONFIG from "../config";
import { encryptData } from "./crypto";

export const PrivateRoute = () => {
  const location = useLocation();

  let auth = useSelector((x) => x.auth.value);

  if (!auth || !auth.token) {
    const storedAuth = localStorage.getItem("auth");
    if (storedAuth) {
      auth = JSON.parse(storedAuth);
    }
  }

  if (auth === null || auth === undefined) {
    return null;
  }

  if (!auth.token) {
    const roleId = Number(auth?.user?.role_id);

    if (roleId === Number(CONFIG.ROLE_ADMIN)) {
      return <Navigate to="/secure/login" replace />;
    }

    return <Navigate to="/login" replace />;
  }

  const isOwner = Number(auth.user?.role_id) === CONFIG.ROLE_OWNER;
  const data = localStorage.getItem(CONFIG.login_data);
  const authUser = data ? JSON.parse(data) : {};

  if (isOwner) {
    if (!authUser?.is_store_selected && location.pathname !== "/store-add") {
      return <Navigate to="/store-add" replace />;
    }
    if (authUser?.is_store_selected && location.pathname === "/store-add") {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <Outlet />;
};

export const PublicRoute = () => {
  let auth = useSelector((x) => x.auth.value);

  if (typeof auth !== "object") {
    auth = JSON.parse(auth);
  }

  const location = useLocation();

  const data = localStorage.getItem(CONFIG.login_data);
  const authUser = data ? JSON.parse(data) : {};
  const deviceToken = localStorage.getItem("app_fcm_token");

  const isOwner = Number(auth?.user?.role_id) === CONFIG.ROLE_OWNER;

  if (!auth?.token && deviceToken && location.pathname === "/") {
    return <Navigate to="/login" replace />;
  }

  if (auth?.token) {
    if (isOwner && authUser?.is_store_selected === 0) {
      return <Navigate to="/store-add" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
// export const PublicRoute = () => {

//   let auth = useSelector((x) => x.auth.value);
//   if (typeof auth != "object") {
//     auth = JSON.parse(auth);
//   }
//   if (auth?.token) {
//     return <Navigate to="/dashboard" />;
//   } else {
//     return <Outlet />;
//   }
// };

export const formatRequest = (data) => {
  if (CONFIG.IS_JSON) {
    return data;
  }

  return {
    q: encryptData(data),
  };
};

// src/styles/reactSelectStyles.js
export const customStyles = (darkMode) => ({
  control: (provided, state) => ({
    ...provided,
    backgroundColor: darkMode ? "#1f2937" : "#f9fafb", // gray-800 vs gray-50
    border: "none",
    borderRadius: "1rem",
    padding: "0.5rem 1rem",
    boxShadow: state.isFocused
      ? darkMode
        ? "0 0 0 4px rgba(245,158,11,0.4)" // amber-500 for dark
        : "0 0 0 4px hsl(27 85% 48%)" // amber-500 light
      : "none",
    fontWeight: 500,
    outline: "none",
    cursor: "pointer",
    color: darkMode ? "#f9fafb" : "#111827",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: darkMode ? "#fbbf24" : "hsl(27 85% 48%)", // amber-400 / amber-500
  }),
  indicatorSeparator: () => null,
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? darkMode
        ? "#374151" // gray-700 focus
        : "#d1fae5" // green-100 focus
      : darkMode
        ? "#1f2937" // gray-800
        : "white",
    color: state.isFocused
      ? darkMode
        ? "#fbbf24" // amber text on focus
        : "hsl(27 85% 48%)"
      : darkMode
        ? "#f9fafb" // text light in dark mode
        : "#111827",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "1rem",
    overflow: "hidden",
    backgroundColor: darkMode ? "#1f2937" : "white",
    color: darkMode ? "#f9fafb" : "#111827",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: darkMode ? "#f9fafb" : "#111827",
  }),
});

export const formatTime = (time24) => {
  if (!time24) return ""; // or return "N/A"

  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr, 10);

  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;

  return `${hour}:${minute} ${ampm}`;
};

export function formatCurrencyINR(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  }).format(amount);
}

export function maskMobile(mobile = "") {
  const str = String(mobile);

  if (str.length < 10) return str;

  return `+91 ${str.slice(0, 2)}XXXXXX${str.slice(-2)}`;
}
